import moment from "moment-timezone";
import momenttz from "moment-timezone";
import { DateTime } from "luxon";
 
export const setProfileTimezone = (data) => {

    if(data.userTimezone == '' || data.userTimezone  == undefined){
        return parsedPofileTz(data.defaultparsedPofileTz)
    }else{
        return parsedPofileTz(data.userTimezone)
    }
}

export const setUserTz = (data) => {
    if(data.userTimezone == '' || data.userTimezone  == undefined){
        return data.defaultTz
    }else{
        return data.userTimezone
    }
}

export const setUserSignatureTz = (data) => {
    if(data.userTimezone == '' || data.userTimezone  == undefined){
        return parsedUserSignatureTz(data.defaultTz)
    }else{
        return parsedUserSignatureTz(data.userTimezone)
    }
}

export const tz = (date, usertz) => {
    return momenttz.tz(date, usertz)
}

function parsedUserSignatureTz(tz){
    let overrideZone = DateTime.fromISO(new Date().toJSON(), { zone: tz });
    const dt = overrideZone.toFormat("ccc LLL dd yyyy TT") 
    const zz = overrideZone.toFormat("ZZZ (ZZZZZ)")
    return dt + " GMT" + zz
}

function parsedPofileTz(tz){
    moment.tz.setDefault(tz);
    let parseDate =  moment().format('ddd, h:mma');
    let parsedTz = moment.tz(moment(), tz).format('Z');
    return `${parseDate} (GMT ${parsedTz})`
}

